import { Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react"
import React from "react";

const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.4); opacity: 0.6; }
  100% { transform: scale(1); opacity: 1; }
`;

interface Props {
  animationCount?: number
}

export const PulsingDot: React.FC<Props> = ({ animationCount }) => {
  return (
    <Box
      w="10px"
      h="10px"
      bg="#FE6E6F"
      borderRadius="full"
      animation={`${pulse} 1s ${animationCount ? animationCount : 5} ease-in-out`}
    />
  );
};